/*import API from '../axios';

// Create Razorpay order on backend
export const createPaymentIntent = (bookingId) => 
  API.post('/payment/order', { bookingId });

// Step 1: Verify payment after successful Razorpay transaction
export const verifyPayment = (data) => 
  API.post('/payment/verify', data);

// Step 2: Send confirmation emails after payment verification
export const sendBookingEmail = (bookingId) => 
  API.post('/email/booking', { bookingId });
*/
import API from '../axios';

// Payment API calls

// Create a Razorpay order on the backend
export const createPaymentIntent = (bookingId) => 
  API.post('/payment/order', { bookingId });

// Verify payment after successful Razorpay transaction
export const verifyPayment = (data) => 
  API.post('/payment/verify', data);

// Send booking confirmation emails after payment verification
export const sendBookingEmail = (bookingId) => 
  API.post('/email/booking', { bookingId });
